// extracted by mini-css-extract-plugin
module.exports = {"container":"Verify_container__VHMeW","tick":"Verify_tick__2Cum7","loader":"Verify_loader__37YjJ"};